import React, { useState, useEffect } from "react";
import Header from "../../components/Layout/Header";
import Footer from "../../components/Layout/Footer"; // ✅ Added import
import Forbidden403 from "../page403";
import MappedSpecialities from "./Components/MappedComponent";
import SpecialitiesMappedList from "./Components/SpecialitiesMappedList";

export default function Specialities() {
  const [selectedState, setSelectedState] = useState();
  const [stateListFromLocalStorage, setStateListFromLocalStorage] = useState([]);
  const [userType, setUserType] = useState(false);
  const [storedState, setStoredState] = useState(
    JSON.parse(localStorage.getItem("selectedState"))
  );
  const [calendarEmail, setCalendarEmail] = useState("");
  const [showHelpModal, setShowHelpModal] = useState(false);

  const [selectedSpecialityForMapping, setSelectedSpecialityForMapping] =
    useState(null);

  const [refetchKey, setRefetchKey] = useState(0); // ✅ controls list refresh

  const handleRowClick = (specialityId) => {
    setSelectedSpecialityForMapping(specialityId);
  };

  const transformData = (items) =>
    items.map(({ id, name }) => ({
      value: id,
      label: name,
    }));

  useEffect(() => {
    const userData = JSON.parse(
      localStorage.getItem("loggedInUserInfo") || "{}"
    );

    setUserType(userData?.user_type);

    const transformedData = transformData(userData?.state || []);
    setStateListFromLocalStorage(transformedData);

    if (!storedState && transformedData.length > 0) {
      localStorage.setItem("selectedState", JSON.stringify(transformedData[0]));
      setSelectedState(transformedData[0]);
    }

    if (userData?.email) setCalendarEmail(userData.email);
  }, [storedState]);

  // ✅ Callback to refresh list when a mapping is saved
  const fetchSpecialitiesList = () => {
    console.log("Mapping saved, refreshing list...");
    setRefetchKey((k) => k + 1);
  };

  // Guard route access
  if (userType !== false && userType !== "CCN_Internal") {
    return <Forbidden403 />;
  }

  return (
    <>
      <Header from="CCN Dashboard" />
      <div className="bg-primary pt-5 pb-20">
        <div className="container">
          <div className="row">
            <div className="col col-md-auto bg-primary mb-3">
              <h1 className="text-secondary fw-boldest point-42">Specialities</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white py-3 clearfix">
        <div className="container mt-n20">
          <div className="row">
            <MappedSpecialities
              selectedSpecialityId={selectedSpecialityForMapping}
              onMappingSaved={fetchSpecialitiesList} // ✅ callback
            />
            <SpecialitiesMappedList
              onRowClick={handleRowClick}
              refetchTrigger={refetchKey} // ✅ forces reload on change
            />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
